import React, {  useEffect, useState, useRef  } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { EffectCreative } from 'swiper/modules';
import './Leadership.css';
import { faLock, faFileSignature, faFileContract, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom"
import CONFIG from "./config";

const Header = () => {
const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
const [activeIndex, setActiveIndex] = useState(0);
const [activeTab, setActiveTab] = useState('Empower');
const [openBioIndex, setOpenBioIndex] = useState(null);
const [selectedMember, setSelectedMember] = useState(null);
const [openIndex, setOpenIndex] = useState(null);
const [directors, setDirectors] = useState([]);
const [showAll, setShowAll] = useState(false);
const [openBoardIndex, setOpenBoardIndex] = useState(null); // For boardMembers
const [openSangliIndex, setOpenSangliIndex] = useState(null);
const prevRef = useRef(null);
const nextRef = useRef(null);
const swiperRef = useRef(null);
const [expandedBox, setExpandedBox] = useState(null);
const [current, setCurrent] = useState(0);
const [expanded, setExpanded] = useState(false);

const nextSlide = () => {
  setCurrent((prev) => (prev + 1) % length);
};

const prevSlide = () => {
  setCurrent((prev) => (prev - 1 + length) % length);
};
const toggleBox1 = () => {
    setExpandedBox(expandedBox === "box1" ? null : "box1");
};

const images = [
    'Amhi-Kon-Ahot-banner.png',
    
];
const length = images.length;
useEffect(() => {
    if (
      swiperRef.current &&
      prevRef.current &&
      nextRef.current &&
      swiperRef.current.params
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      // Re-init navigation
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);
       
  

  const closeBio = () => {
  setSelectedMember(null);
};  
 
  
const toggleBio = (index) => {
  setOpenBioIndex(prevIndex => (prevIndex === index ? null : index));
};

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
    const handleBioClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
 const handleClose = () => {
  setOpenBoardIndex(null);      // For Kolhapur modal
  setOpenSangliIndex(null);     // ✅ Add this line for Sangli modal
};



  
  const pastDirectors = [
  { name: "Gerry Barañano", years: "2002–2003" },
  { name: "Larry Landweber", years: "2002–2003" },
  { name: "Alan Levin", years: "2002–2003" },
  { name: "Andy Linton", years: "2002–2003" },
  { name: "Marc Rotenberg", years: "2002–2006" },
  { name: "Frode Greisen", years: "2002–2004" },
  { name: "David Maher", years: "2002–2004" },
  { name: "Lynn St. Amour", years: "2002–2013", note: "ISOC Liaison" },
  { name: "Geoff Houston", years: "2003–2005" },
  { name: "Kenny Huang", years: "2003–2004" },
  { name: "Amadeu Abril i Abril", years: "2003–2005" },
  { name: "Susan Estrada", years: "2004–2007" },
  { name: "Barbara Fraser", years: "2004, 2005–2007, 2008–2011" },
  { name: "Eva Frolich", years: "2004–2007" },
  { name: "Glenn Ricart", years: "2004–2006, 2007–2011" },
  { name: "Pindar Wong", years: "2006" },
  { name: "Kuo-Wei Wu", years: "2008–2009" },
  { name: "Raimundo Beca", years: "2011–2014" },
  { name: "Erik Huizer", years: "2007–2015" },
  { name: "Maarten Botterman", years: "2008–2016" },
  { name: "Alexa Raad", years: "2009–2010", note: "non-voting" },
  { name: "Amitabh Singhal", years: "2010–2016, 2019–2021" },
  { name: "Art Reilly", years: "2011–2017" },
  { name: "Eric Burger", years: "2015–2017" },
  { name: "Ingrid Srinath", years: "2013–2018" },
  { name: "Hartmut Glaser", years: "2014–2018" },
  { name: "Kathryn Brown", years: "2013–2018", note: "ISOC Liaison" },
  { name: "Roberto Gaetano", years: "2013–2019" },
  { name: "Tosca Bruno-van Vijfeijken", years: "2016–2019" },
  { name: "Suzanne Woolf", years: "2018–2019" },
  { name: "Jay Daley", years: "2018–2020" },
  { name: "Greg Kapfer", years: "2019–2022" },
  { name: "Lise Fuhr", years: "2016–2022" },
  { name: "Narelle Clark", years: "2018–2023" },
  { name: "Jeffrey Bedser", years: "2017–2023" },
  { name: "Andrew Sullivan", years: "2018–2024", note: "ISOC Liaison" },
  { name: "Keith Davidson", years: "2019–2025" },
];
 const visibleDirectors = showAll ? pastDirectors : pastDirectors.slice(0, 7);
   // PIRAdvisoryData.js
const advisoryCouncil = [
  {
    name: "John Doe",
    year: "2021–2023",
    info: "John is a policy expert with extensive experience in internet governance.",
  },
  {
    name: "Jane Smith",
    year: "2020–2022",
    info: "Jane is a cybersecurity advisor with years of experience in digital rights.",
  },
  {
    name: "Carlos Alvarez",
    year: "2019–2021",
    info: "Carlos brings insights from his background in nonprofit leadership.",
  },
   {
    name: "Jane Smith",
    year: "2020–2022",
    info: "Jane is a cybersecurity advisor with years of experience in digital rights.",
  },
  {
    name: "Carlos Alvarez",
    year: "2019–2021",
    info: "Carlos brings insights from his background in nonprofit leadership.",
  },
   {
    name: "Jane Smith",
    year: "2020–2022",
    info: "Jane is a cybersecurity advisor with years of experience in digital rights.",
  },
  {
    name: "Carlos Alvarez",
    year: "2019–2021",
    info: "Carlos brings insights from his background in nonprofit leadership.",
  },
   {
    name: "Jane Smith",
    year: "2020–2022",
    info: "Jane is a cybersecurity advisor with years of experience in digital rights.",
  },
  {
    name: "Carlos Alvarez",
    year: "2019–2021",
    info: "Carlos brings insights from his background in nonprofit leadership.",
  },
  // Add more as needed
];



const teamData = [
 {
    name: "मा. अ‍ॅड. श्री. प्रसाद करंदीकर साहेब",
    title: "(अध्यक्ष – महाराष्ट्र लोकाधिकार समिती)",
    image: "img7.png",
    bio: `नेतृत्व जे दिशाही देते आणि आधारस्तंभही ठरते!

मा. अ‍ॅड. श्री. प्रसाद करंदीकर साहेब हे महाराष्ट्र लोकाधिकार समितीचे संस्थापक अध्यक्ष असून, संघटनेच्या उभारणीपासून ते तिच्या आजच्या
व्यापक विस्तारापर्यंत त्यांच्या योगदानाची अमूल्य छाया लाभलेली आहे. कायद्यावरील त्यांचे सखोल ज्ञान, तसेच डॉ. बाबासाहेब आंबेडकर यांच्या
संविधानाची त्यांना असलेली स्पष्ट व सशक्त समज, यामुळे ते संघटनेचा खरा कणा व मार्गदर्शक मानले जातात. समाजहितासाठीची तळमळ
आणि मतभेदांवरही ठाम राहून न्यायासाठी उभे राहण्याची त्यांची भूमिका ही संघटनेच्या प्रत्येक स्तरावर प्रेरणादायी ठरलेली आहे.

दृष्टी, दिशा आणि ध्येयाच्या प्रवाहातले नेतृत्व
मा. करंदीकर साहेबांचा दृष्टिकोन नेहमीच स्पष्ट, दूरदृष्टीपूर्ण आणि धोरणात्मक राहिला आहे. त्यांनी अन्यायग्रस्त कर्जदार, शेतकरी, व्यापारी आणि
उद्योजक यांच्या न्यायहक्कांसाठी अखंडपणे आणि समर्पितपणे संघर्ष केला आहे. केवळ कायद्याच्या तांत्रिक बाबींमध्ये प्रभुत्व मिळवण्यातच न
थांबता, त्यांनी आर्थिक व्यवस्थेतील गुंतागुंतीच्या यंत्रणांचा अभ्यास करत लोकशाही मूल्यांचा व्यापक अंगीकार केला आहे. त्यांची नेतृत्वशैली ही
सामर्थ्य आणि संवेदनशीलता यांचा समतोल साधणारी आहे.

संघटनेचा आत्मा — एक अभ्यासू व प्रेरणादायी नेतृत्व
संघटनेच्या प्रगतीमागे आणि झपाट्याने विस्तारामागे त्यांची दूरदृष्टी, गाढा अभ्यास व कार्यकर्त्यांवरचा मनोबल वाढवणारा विश्वास हे मूलभूत
घटक ठरले आहेत. ते फक्त नेतृत्व करत नाहीत, तर प्रत्येक कार्यकर्त्याच्या क्षमतेवर विश्वास ठेवून त्याला घडवतात, जागवतात आणि उभं
करतात. त्यांच्या मार्गदर्शनामुळे कार्यकर्त्यांमध्ये स्वतंत्र विचार, आत्मविश्वास आणि सामाजिक लढ्याची उर्मी निर्माण होते.

नेतृत्व जे दीपस्तंभासारखे प्रकाशमान आहे
मा. करंदीकर साहेबांचे नेतृत्व हे महाराष्ट्र लोकाधिकार समितीच्या प्रवासातील दीपस्तंभ ठरले आहे —
ज्याच्या प्रकाशात हजारो अन्यायग्रस्त, आर्थिक अडचणीत सापडलेले लोक न्याय आणि आत्मसन्मानाचा मार्ग शोधू शकले आहेत. त्यांचा स्पष्ट
विचारसरणी, अटळ निश्चय आणि संविधाननिष्ठ भूमिका यामुळे संघटना आज सामाजिक न्यायाच्या लढ्यात एक बलाढ्य आवाज बनली आहे.

संघटनेच्या उभारीला मिळालेले प्रगल्भ नेतृत्व

या महान नेतृत्वाच्या मार्गदर्शनाखाली महाराष्ट्र लोकाधिकार समिती अधिक सशक्त, सुव्यवस्थित आणि परिणामकारक संघटना म्हणून उदयास येत
आहे — जिचा थेट लाभ लाखो गरजू, अन्यायग्रस्त आणि वंचित घटकांपर्यंत पोहोचत आहे.`
  },

 {
  name: 'मा. श्री. योगेश भारत वाघमारे साहेब',
  title: '(महाराष्ट्र राज्य कार्याध्यक्ष, महाराष्ट्र लोकाधिकार समिती)',
  image: 'yogesh.png',
  bio: `मा. श्री. योगेश भारत वाघमारे हे महाराष्ट्र लोकाधिकार समितीचे महाराष्ट्र राज्य कार्याध्यक्ष म्हणून अतिशय महत्त्वाची आणि जबाबदारीची
भूमिका समर्थपणे पार पाडत आहेत. जमिनीशी असलेली त्यांची नाळ, स्थानिक प्रश्नांची सखोल जाण आणि संघटनेतील प्रत्येक कार्यकर्त्याशी
असलेला आत्मीय संबंध, ही त्यांच्या नेतृत्वाची खरी ओळख आहेत.

त्यांचा स्वभाव अत्यंत संयमी, समजूतदार आणि दूरदृष्टीपूर्ण आहे. बँकिंग क्षेत्रातील बारकावे, आर्थिक संस्थांची कार्यपद्धती आणि कर्जवसुलीच्या
कायदेशीर प्रक्रियेवरील त्यांचे प्रभुत्व संघटनेच्या लढ्याला विचारशील दिशा आणि स्थैर्य प्रदान करते. त्यांनी संघटनेच्या धोरणात्मक
निर्णयप्रक्रियेत महत्त्वाची भूमिका बजावत, विविध सामाजिक स्तरांतील शेतकरी, व्यापारी, उद्योजक आणि सामान्य नागरिकांना न्याय मिळवून
देण्यासाठी सातत्याने प्रयत्नशील राहिले आहेत.

मा. वाघमारे साहेब केवळ एक पदाधिकारी नसून, ते कार्यकर्त्यांसाठी विश्वासाचा आधारस्तंभ ठरले आहेत. त्यांच्या मार्गदर्शनामुळे संघटनेतील
शिस्त, एकसंघपणा आणि परिणामकारकता अधिक दृढ झाली आहे. त्यांनी निर्माण केलेल्या विश्वासाच्या आणि सकारात्मक ऊर्जेच्या
वातावरणामुळे कार्यकर्त्यांमध्ये नवचैतन्य आणि आत्मविश्वास निर्माण झाला आहे, जे संघटनेच्या संघर्षांना अधिक बळ देत आहे.

त्यांचे नेतृत्व म्हणजे महाराष्ट्र लोकाधिकार समितीसाठी एक प्रेरणास्त्रोत आहे—असा स्रोत जो समाजातील अंधारलेल्या प्रश्नांना उजाळा देतो आणि
अन्यायग्रस्तांसाठी नव्या आशेचे किरण निर्माण करतो. त्यांच्या कार्यामुळे ही संघटना केवळ विस्तारत नाही, तर व्यापक जनतेसाठी न्यायाचा
दीपवत ठरते.`
},

 {
  name: 'मा. श्री. हेमंत दोराके साहेब',
  title: '(उपाध्यक्ष, महाराष्ट्र लोकाधिकार समिती)',
  image: 'ai.png',
  bio: `मा. श्री. हेमंत दोराके हे महाराष्ट्र लोकाधिकार समितीचे उपाध्यक्ष म्हणून संघटनेत एक अत्यंत सक्रीय, बांधील आणि प्रेरणादायी नेतृत्व निभावत
आहेत. त्यांनी आपल्या सार्वजनिक जीवनाची सुरुवात आरपीआय (आठवले) या प्रमुख सामाजिक-राजकीय पक्षाच्या माध्यमातून केली असून, ते
विविध सामाजिक आणि आर्थिक प्रश्नांवरील चळवळींमध्ये सातत्याने सक्रीय राहिलेले आहेत. विशेषतः दलित समाजाच्या हक्कांसाठीच्या
चळवळीत त्यांचे योगदान अत्यंत महत्त्वाचे आणि उल्लेखनीय आहे.

श्रमिक, शेतकरी, वंचित आणि दुर्बल घटकांच्या हक्कांसाठी ते कायमच अग्रस्थानी राहतात. संघटनेच्या प्रत्येक आंदोलनात, मोहिमेत आणि निर्णय
प्रक्रियेत त्यांचे नेतृत्व दृढ आणि दिशादर्शक असते. संघटनेला अधिक सर्वसमावेशक, प्रभावी आणि संघटित बनवण्यासाठी त्यांनी शिस्तबद्ध
संघटनात्मक दृष्टिकोन स्वीकारला आहे, ज्यामुळे कार्यकर्त्यांमध्ये दृढ विश्वास आणि संघभावना निर्माण झाली आहे.

मा. दोराके साहेब यांचा कार्यपथ म्हणजे समर्पण, संयम आणि संघटनेच्या मूलभूत ध्येयांबद्दलची निष्ठा. कोणतेही आव्हान आले तरी
त्यांच्यातील शांत, अभ्यासू आणि धैर्यशील नेतृत्व कार्यकर्त्यांसाठी प्रेरणेचा स्त्रोत ठरते. ते केवळ निर्णय घेणारे नेतृत्वकर्ते नाहीत, तर प्रत्येक
कार्यकर्त्याच्या अडचणी समजून घेत त्यांना योग्य मार्गदर्शन करणारे सहकारी आहेत. त्यामुळे संघटनेतील प्रत्येक सदस्य अधिक सक्षम, जागरूक
आणि आत्मविश्वासपूर्ण वाटतो.

सामाजिक न्याय, आर्थिक स्वायत्तता आणि लोकशाही मूल्यांप्रती त्यांचा दृढ विश्वास आहे. या तत्वांना त्यांनी संघटनेच्या प्रत्येक कार्यपद्धतीमध्ये
प्रत्यक्षात उतरवले आहे. त्यांच्या प्रगल्भ नेतृत्वामुळे महाराष्ट्र लोकाधिकार समिती अधिक सुसंगत, समन्वित आणि प्रभावी बनली असून, आगामी
काळात समिती सामाजिक परिवर्तनासाठी अधिक ठोस आणि व्यापक पावले टाकेल, असा विश्वास त्यांच्या कार्यातून अधोरेखित होतो.`
},

  {
  name: 'मा. श्री. सदीक डोंगरकर साहेब',
  title: '(महासचिव, महाराष्ट्र लोकाधिकार समिती)',
  image: 'img5.png',
  bio: `मा. श्री. सदीक डोंगरकर हे महाराष्ट्र लोकाधिकार समितीचे महासचिव असून, ते एक दूरदृष्टी असलेले, संघर्षशील आणि सामाजिक न्यायासाठी
झटणारे प्रगल्भ नेतृत्व आहेत. त्यांच्या नेतृत्वाखाली संघटनेने अनेक महत्त्वपूर्ण सामाजिक व आर्थिक प्रश्नांवर प्रभावी कार्य केले आहे.
संघटनेचे पहिले सरपंच म्हणून त्यांनी सलग दहा वर्षे जबाबदारी पार पाडली. या कालावधीत त्यांनी सर्वसामान्य लोकांचे हक्क अबाधित
राखण्यासाठी सातत्याने आवाज उठवला. बेकायदेशीर जप्ती, अन्यायकारक वसुलीविरोधात त्यांनी अनेक आंदोलनं, चर्चासत्रं आणि कायदेशीर लढाया
यशस्वीरित्या मार्गी लावल्या.

त्यांचा ठाम विश्वास आहे की प्रत्येक नागरिकाला सन्मानाने आणि आत्माभिमानाने जगण्याचा अधिकार असायला हवा, आणि याच तत्त्वासाठी ते
सातत्याने काम करत आहेत. विशेषतः, त्यांनी शेतकऱ्यांच्या आत्महत्या या गंभीर सामाजिक समस्येकडे गांभीर्याने लक्ष वेधले आहे. गेल्या दोन
वर्षांपासून त्यांनी या विषयावर जनजागृती मोहिमा, आंदोलनं आणि संवादमाध्यमांतून भान जागवणारे लेख प्रसिद्ध करून समाजमन हलवले
आहे.

त्यांचे प्रयत्न केवळ विरोध नोंदविण्यापुरते मर्यादित न राहता, त्यांनी संबंधित यंत्रणांपर्यंत निवेदनं पोचवली आहेत आणि समस्येचे मूलभूत उपाय
शोधण्यासाठी सातत्याने चर्चा आणि दबाव निर्माण केला आहे.

मा. डोंगरकर यांचे कार्यध्येय म्हणजे एक न्याय्य, व्यसनमुक्त, आणि सशक्त महाराष्ट्र निर्माण करणे—जिथे सर्वसामान्य माणसाच्या हक्कांचे
संरक्षण सर्वोच्च प्राधान्य असेल. त्यांच्या मार्गदर्शनाखाली महाराष्ट्र लोकाधिकार समितीने दुर्बल घटकांसाठी निःस्वार्थ लढा दिला आहे, आणि हे
कार्य भविष्यातही अधिक व्यापक आणि प्रभावी स्वरूपात सुरू राहील, अशी खात्री वाटते.`
},

{
  name: 'मा. श्री. अविनाश गंगाधर पराडकर',
  title: '(प्रदेश समन्वयक, महाराष्ट्र लोकाधिकार समिती)',
  image: 'img4.png',
  bio: `मा. अविनाश गंगाधर पराडकर हे महाराष्ट्र लोकाधिकार समितीचे प्रदेश समन्वयक म्हणून अत्यंत सक्रिय व नेतृत्वक्षम भूमिका बजावत आहेत.
उत्कृष्ट मुक्तलेखक म्हणून त्यांची वेगळी ओळख असून, सामाजिक आणि आर्थिक विषयांवरील त्यांच्या लेखनातून जनजागृती घडते आणि
समाजात ठोस बदल घडवण्यास दिशा मिळते.

विद्यार्थीदशेपासूनच ते अखिल भारतीय विद्यार्थी परिषदेसारख्या संघटनांमध्ये सक्रीय असून त्यांनी आंदोलनात्मक नेतृत्वाची समृद्ध परंपरा
जोपासली आहे. संघटनेच्या प्रारंभापासूनच ते विविध महत्त्वाच्या सामाजिक चळवळींमध्ये अग्रभागी राहिले आहेत. बँका व पतसंस्थांच्या मनमानी
कारभाराविरोधात त्यांनी दीर्घकाळ आवाज उठवला आहे. २००७ पासून ते महाराष्ट्र लोकाधिकार समितीच्या माध्यमातून अन्यायाविरोधात
सातत्याने लढा देत आहेत.

सिंधुदुर्ग जिल्ह्यातील 'फयान' वादळाच्या वेळी मच्छीमार बांधवांच्या न्यायासाठी उभारलेली चळवळ हे त्यांच्या पारदर्शक, आक्रमक आणि
संवेदनशील कार्यशैलीचे उत्तम उदाहरण ठरते.

"एजीपी क्रिएशन" या माध्यमसंस्थेमार्फत ते मीडिया आणि सोशल मीडियाच्या क्षेत्रातही सक्रीय असून, माहिती तंत्रज्ञानाचा वापर करून संघटनेच्या
कार्यात नवचैतन्य आणत आहेत. त्यांचा ठाम विश्वास आहे की सामाजिक अन्याय व निराशेने उद्भवणाऱ्या मानसिक तणावांवर मात
करण्यासाठी संघटित, रचनात्मक आणि दीर्घकालीन प्रयत्नांची नितांत आवश्यकता आहे.

त्यांचा आधुनिक दृष्टिकोन, कार्यपद्धतीतील शिस्त, कार्यकर्त्यांमध्ये प्रेरणा जागवणारी वृत्ती आणि सामाजिक समर्पण भाव यामुळे मा. अविनाश
पराडकर हे संघटनेच्या प्रदेशीय नेतृत्वाचे खरे अधिष्ठान ठरले आहेत. त्यांच्या नेतृत्वामुळे महाराष्ट्र लोकाधिकार समिती अधिक परिणामकारक,
व्यापक आणि लोकाभिमुखतेने सामाजिक परिवर्तनाच्या दिशेने वाटचाल करत आहे.`
},

  {
  name: 'मा. श्री. नंदकुमार लोखंडे',
  title: '(जिल्हाध्यक्ष-कोल्हापूर, महाराष्ट्र लोकाधिकार समिती)',
  image: 'img.png',
  bio: `मा. नंदकुमार लोखंडे हे महाराष्ट्र लोकाधिकार समितीचे कोल्हापूर जिल्हाध्यक्ष म्हणून अत्यंत सक्रिय, समर्पित आणि जबाबदारीने कार्यरत आहेत.
छत्रपती शिवाजी महाराजांच्या राष्ट्रनिष्ठ आणि जनकल्याणकारी विचारसरणीची प्रेरणा घेऊन त्यांनी समितीचा उद्देश समाजाच्या तळागाळापर्यंत
पोहोचवण्याचा ठाम निर्धार केला आहे.

कोल्हापूर जिल्ह्यातील कर्जबाजारी, अन्यायग्रस्त, वंचित आणि उपेक्षित नागरिकांसाठी त्यांनी विविध आंदोलनांचे नेतृत्व करत त्यांच्या प्रश्नांना
वाचा फोडली आहे. मार्गदर्शन शिबिरे, जनजागृती मोहीमा आणि कायदेशीर लढ्यांतून त्यांनी शेकडो नागरिकांना न्याय मिळवून देण्यात यश
मिळवले आहे. त्यांच्या दूरदृष्टीपूर्ण नेतृत्वामुळे या समाजघटकांचा एक सशक्त लोकआवाज निर्माण झाला आहे, जो अन्यायाविरुद्ध निर्भीडपणे
उभा राहतो.

मा. लोखंडे यांचे कार्य केवळ आंदोलनांपुरते सीमित नसून, कार्यकर्त्यांचे प्रशिक्षण, कायदेशीर सल्ला, जनजागृती आणि संघटनात्मक बांधणी
यामध्येही त्यांचा सक्रिय सहभाग आहे. कार्यकर्त्यांच्या क्षमताविकासासाठी त्यांनी घेतलेले उपक्रम आणि मार्गदर्शन समितीच्या बळकटीकरणामध्ये
मोलाचे ठरले आहेत.

सामाजिक भान, साधेपणा आणि कठोर परिश्रम यांच्या बळावर मा. नंदकुमार लोखंडे हे कोल्हापूर जिल्ह्यातील महाराष्ट्र लोकाधिकार समितीचे
एक विश्वासार्ह व खंबीर आधारस्तंभ म्हणून ओळखले जातात. त्यांच्या नेतृत्वाखाली समितीने कोल्हापूर आणि आसपासच्या भागांमध्ये शेकडो
गरजू नागरिकांपर्यंत न्याय आणि मदतीचा हात पोहोचवला आहे.

भविष्यातही, सामाजिक न्यायाच्या लढ्यात समिती अधिक प्रभावी आणि व्यापक पद्धतीने कार्यरत राहील, याचा निर्धार त्यांनी आपल्या कार्यातून
सातत्याने सिद्ध केला आहे. त्यांच्या प्रेरणादायी नेतृत्वामुळे महाराष्ट्र लोकाधिकार समिती कोल्हापूर जिल्ह्यात सामाजिक परिवर्तनाचा एक
बळकट स्तंभ ठरत आहे.`
},

   {
  name: 'मा. श्री. विक्रम नावडकर साहेब',
  title: '(जिल्हाध्यक्ष-सांगली, महाराष्ट्र लोकाधिकार समिती)',
  image: 'img6.png',
  bio: `मा. श्री. विक्रम नावडकर हे सांगली जिल्ह्याचे जिल्हाध्यक्ष म्हणून महाराष्ट्र लोकाधिकार समितीमध्ये अत्यंत सक्रिय, समर्पित आणि सशक्त
नेतृत्व करत आहेत. कायदा, बँकिंग प्रणाली आणि कर्ज वसुली प्रक्रियेचा सखोल अभ्यास आणि वैयक्तिक अनुभवाच्या आधारे त्यांनी या क्षेत्रात
मोठे योगदान दिले आहे. कर्जदारांना फसवणूक करणाऱ्या एजंट, दलाल आणि वसुली गटांचे खरे स्वरूप समाजासमोर आणण्याचा त्यांचा प्रयत्न
उल्लेखनीय आहे. त्यांच्या या कार्यामुळे कर्जबाजारी नागरिकांमध्ये जागरूकता वाढून त्यांना योग्य मार्गदर्शनाचा आधार मिळाला आहे.

सांगली जिल्ह्यात विविध ठिकाणी त्यांनी जनजागृती मोहिमा, आंदोलनं, मेळावे आणि सल्लागार शिबिरांचे यशस्वी आयोजन केले आहे. या
उपक्रमांतून असंख्य कुटुंबांना धैर्य, आशा आणि आत्मभान मिळाले असून, त्यांचे जीवन नव्याने उभारण्याची दिशा सापडली आहे. विक्रम साहेबांची
कार्यशैली ही लोकांशी थेट संवाद साधण्यावर आधारित आहे. ते संघटनेच्या विचारसरणीचा संदेश प्रत्येक गरजू व्यक्तीपर्यंत पोहोचवण्यासाठी
सातत्याने झटत आहेत.

त्यांची सामाजिक बांधिलकी, स्पष्टवक्ता भूमिका आणि कृतीप्रधान कार्यपद्धती यामुळे त्यांनी केवळ संघटनेचा विस्तारच साधला नाही, तर
समाजातील वंचित आणि आर्थिकदृष्ट्या दुर्बल घटकांना आपले कायदेशीर हक्क आणि आत्मसन्मानाने जगण्याचा मार्ग दाखवला आहे. त्यांच्या
नेतृत्वामुळे सांगली जिल्ह्यातील महाराष्ट्र लोकाधिकार समिती एक विश्वासार्ह, प्रेरणादायी आणि जनतेच्या हितासाठी झटणारी संघटना म्हणून
ओळखली जाते.

आजही आव्हानात्मक परिस्थितीत जनहिताचा विचार ठेवून ते कार्यरत असून, भविष्यात त्यांच्या दूरदृष्टीपूर्ण नेतृत्वाखाली सांगली जिल्हा आर्थिक
आणि सामाजिक न्यायाच्या लढ्यात अधिक प्रभावीपणे पुढे जाईल, याबाबत संपूर्ण संघटनेला दृढ विश्वास आहे.`
}

];


const boardMembers = [
  {
    name: 'Saerin Cho',
    title: 'Chair (N. America)',
    image: 'https://pir.org/wp-content/uploads/2023/07/saerin_cropped.png',
      bio: 'Saerin brings 20 years of leadership across multiple sectors and champions .ORG for public interest.',
        
  },
  {
    name: 'Eric Burger',
    title: 'Vice Chair (N. America)',
    image: 'https://pir.org/wp-content/uploads/2023/07/Eric_1.jpg',
      bio: 'Saerin brings 20 years of leadership across multiple sectors and champions .ORG for public interest.',
 
  },
  {
    name: 'Lena Beck Rørvig',
    title: 'Treasurer (Europe)',
    image: 'https://pir.org/wp-content/uploads/2023/07/Lena-1.jpg',
  },
  {
    name: 'Michael Silber',
    title: 'Member (Africa)',
    image: 'https://pir.org/wp-content/uploads/2023/07/Silber_web.jpg',
  },
  {
    name: 'George Sadowsky',
    title: 'Member (N. America)',
    image: 'https://pir.org/wp-content/uploads/2024/06/headshot_george.png',
  },
  {
    name: 'Kathryn Kleiman',
    title: 'Member (N. America)',
    image: 'https://pir.org/wp-content/uploads/2023/07/Kathy.jpeg',
  },
  {
    name: 'Oluwaseun (Seun) Ojedeji',
    title: 'Member (Africa)',
    image: 'https://pir.org/wp-content/uploads/2025/07/seun-2-e1751982753129.png',
  },
  {
    name: 'Jon Nevett',
    title: 'Non-Voting Member (N. America)',
    image: 'https://pir.org/wp-content/uploads/2024/06/Jon_2_hi-res.jpg',
  },
  {
    name: 'Sally Wentworth',
    title: 'ISOC CEO & Liaison',
    image: 'https://pir.org/wp-content/uploads/2024/06/Sally-new-Headshot2-2024.jpg',
  },
];

const navItems = [
  { title: 'आम्ही कोण आहोत?', path: '/leadership' },
  { title: 'बातम्या आणि ब्लॉग', path: '/news' },
  { title: 'संपर्क करा', path: '/contact' },
];

  return (
    <>
    
         {/* Header */}
               <header className="header">
                             <div className="nav-container">
                               <div className="logo">
                                 <Link to="/">
                                   <img src="web.png" alt="PIR Logo" />
                                 </Link>
                               </div>
                           
                               {/* Desktop Nav */}
                              <nav className="nav-links">
  {navItems.map((item, index) => (
    <div key={index} className="nav-item">
      <NavLink
        to={item.path}
        className={({ isActive }) =>
          isActive ? "nav-button active" : "nav-button"
        }
      >
        {item.title}
      </NavLink>
    </div>
  ))}
</nav>

                               
                           
                               {/* Search + Title */}
                               <div className="search-language" style={{ position: "relative" }}>
                                 <div
                                   style={{
                                     position: "absolute",
                                     top: "-19px",
                                     left: "16px",
                                     fontSize: "22px",
                                     color: "#FF6F00",
                                     fontFamily: "Mukta, sans-serif",
                                     whiteSpace: "nowrap",
                                     zIndex: 10,
                                     pointerEvents: "none",
                                   }}
                                 >
                                   <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
                                 </div>
                           
                                 <div className="pir-search-wrapper">{/* Search Bar */}</div>
                               </div>
                           
                               {/* Hamburger Toggle */}
                               <button
                                 className="mobile-toggle"
                                 onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                               >
                                 ☰
                               </button>
                             </div>
                           
                             {/* Mobile Menu */}
                             {isMobileMenuOpen && (
                               <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
                             {navItems.map((item, index) => (
                               <Link
                                 key={index}
                                 className="mobile-link"
                                 to={item.path}
                                 onClick={() => setMobileMenuOpen(false)}
                               >
                                 {item.title}
                               </Link>
                             ))}
                           </div>
                             )}
                           </header>
{/* Slider Section */}

  <div className="slider-container">
    {/* Left Side: Image Slider */}
    <div className="slider-left">
      <div className="slider-overlay-left"></div>
      <div className="slide">
      <img src={images[current]} alt={`Slide ${current}`} className="slider-img" />
      </div>

      {/* Move buttons into a bottom-right nav container */}
      <div className="slider-nav">
        <button className="prev-btn" onClick={prevSlide}>❮</button>
        <button className="next-btn" onClick={nextSlide}>❯</button>
      </div>
    </div>

    {/* Right Side: Your Content */}
    {/* <div className="slider-text-content">
      
      <h1>
        "जनतेचा
  बुलंद आवाज...

      </h1>
      <h1>
        
  जो
  प्रत्येक अन्यायाविरोधात
  मिळवून देईल दाद
  निर्विवाद!"
      </h1>
    </div>
     */}
     {/*  <button class="slider-btn">Explore More</button>*/}
  </div>

{/* Slider Section */}
      <section className="executive-management-section">
  <div className="container executive-content">

    {/* Centered Title */}
     <h2 style={{ textAlign: 'center', marginBottom: '20px', fontWeight: 600 }}>
  <span style={{ color: '#FF6F00', fontSize: '2.5rem' }}>
    कार्यकारी व्यवस्थापन – आमची प्रेरणा, आमची दिशा
  </span>
  <br />
  (Executive Management of Maharashtra Lokadhikar Samiti)
</h2>


    <p>
      <b>महाराष्ट्र लोकाधिकार समिती</b> या संघटनेचा मूलभूत उद्देश म्हणजे प्रत्येक नागरिकाला संविधानिक अधिकारांच्या आधारे सक्षम करणे.
      हे ध्येय प्रभावीपणे साकारण्यासाठी, संघटनेच्या पाठीशी उभा आहे एक अनुभवी, समर्पित आणि विविध पार्श्वभूमी असलेला
      <strong> कार्यकारी व्यवस्थापनाचा मजबूत आधारस्तंभ.</strong>
      ही टीम म्हणजे कायदा, समाजकार्य, प्रशासन, आंदोलन आणि नेतृत्व या विविध क्षेत्रांतील तज्ज्ञांचा एक ऊर्जावान संगम आहे.
      प्रत्येक सदस्य एकमेकांकडून शिकत, लोकशाही मूल्ये आत्मसात करत, समाजाच्या शेवटच्या घटकासाठी लढण्याची सामूहिक बांधिलकी जपत कार्यरत आहे.
    </p>

    <ul className="bullet-list">
      आमच्या कार्यकारी व्यवस्थापनात समाविष्ट आहेत:
      <li><b>संचालक मंडळ (Executive Board)</b> – धोरणात्मक निर्णय घेणारे आणि संघटनेची दिशा ठरवणारे नेतृत्व.</li>
      <li><b>सल्लागार परिषद (Advisory Council)</b> – तज्ज्ञांच्या मार्गदर्शनाने संघटनेच्या कार्याला बौद्धिक व नैतिक आधार देणारे सदस्य.</li>
      <li><b>विभागीय समन्वयक (Divisional Coordinators)</b> – विविध जिल्हा आणि विभागांमध्ये संघटनेच्या कामकाजाचा समन्वय आणि अंमलबजावणी करणारे.</li>
      <li><b>तांत्रिक व कायदेशीर मार्गदर्शक मंडळ (Technical and Legal Guidance Board)</b> – कायदेशीर लढ्यांना पाठबळ देणारे आणि धोरणांसाठी तांत्रिक सल्ला देणारे अभ्यासू मंडळ.</li>
    </ul>

    <p>
      या प्रत्येक घटकाचे योगदान हेच आमच्या चळवळीचे खरे बळ आहे. <br />
      आम्ही तुम्हाला आमंत्रण देतो — या <b>प्रेरणादायी नेतृत्व पथकाला</b> जवळून ओळखण्याचे,
      जे आमच्या ध्येयाच्या केंद्रस्थानी आहेत आणि जे प्रत्येक कार्यकर्त्याच्या पाठीशी खंबीरपणे उभे आहेत.
    </p>

  </div>
</section>
<section className="history-section">
  <div className="container history-content">

    {/* Centered Title */}
    <h2 style={{ textAlign: 'center', marginBottom: '20px', fontWeight: 600 }}>
      <span style={{ color: '#FF6F00', fontSize: '2rem' }}>
        संघटनेचा इतिहास – प्रस्तावना
      </span>
    </h2>

    <p>
      २००५ साली महाराष्ट्राच्या मातीत जन्माला आलेली महाराष्ट्र लोकाधिकार समिती ही केवळ एक संघटना नाही, तर ती एक जागृत संविधानिक
      चळवळ आहे. बँकांचे अन्यायकारक वसुली धोरण, फायनान्स कंपन्यांचा दडपशाहीपूर्ण व्यवहार आणि कर्जबाजारी झालेल्या सामान्य जनतेची
      दयनीय अवस्था — या पार्श्वभूमीवर या संघटनेचा उगम झाला.
    </p>

    <p>
      भारतीय संविधानाने दिलेले मूलभूत हक्क केवळ कागदापुरते न राहता ते वास्तवात उतरावेत, या उद्दिष्टाने प्रेरित होऊन समाजाने या संघर्षाची
      गरज ओळखली. आणि या लढ्याचे नेतृत्व लोकशाही मार्गाने, कायद्याच्या चौकटीत राहून, महाराष्ट्र लोकाधिकार समितीने हाती घेतले. शेतकरी,
      छोटे व्यापारी, कामगार, उद्योजक आणि सर्वसामान्य कर्जदार यांचा बुलंद आवाज बनून, संघटनेने केवळ आंदोलनच केले नाही, तर समाजाला एक
      नवी दिशा दिली. जनजागृती मोहिमा, कायदेशीर सल्ला, मार्गदर्शन मेळावे आणि प्रभावी आंदोलनांच्या माध्यमातून हजारो कुटुंबांना आत्मसन्मानाने
      जगण्याचा अधिकार प्राप्त करून दिला. आज ही संघटना महाराष्ट्रभर विस्तारली असून, संविधानाच्या मूल्यांवर आधारलेला सामाजिक बदल
      घडवण्यासाठी ती एक सशक्त माध्यम बनली आहे.
    </p>

    <h3 style={{ fontWeight: 600, marginTop: '30px', color: '#FF6F00' }}>इतिहास</h3>

    <ul className="history-list">
      <li>२००५ – "भारतीय राज्यघटनेला अभिप्रेत लोकाधिकारांसाठी – करूया संघर्ष न्याय्य हक्कांसाठी" या घोषणेसह महाराष्ट्र लोकाधिकार समितीची स्थापना झाली.</li>
      <li>२००८ – पंतप्रधान मुद्रा योजनेची प्रभावी अंमलबजावणी होऊन रोजगारनिर्मिती व्हावी यासाठी बँकांना निवेदन देण्यात आले व जनजागृती कार्यक्रम राबवण्यात आले.</li>
      <li>२०१० – बांदा येथे एका बेकायदेशीर वसुली करणाऱ्या पतसंस्थेच्या अधिकाऱ्याला जनक्षोभातून चोप देण्यात आला.</li>
      <li>२०१८ – ठाणे येथे कर्जबाजारी नागरिकांच्या हक्कांसाठी संघटनेने तीव्र आंदोलन केले.</li>
      <li>२०२० – बँकेने सील केलेल्या घरामध्ये गोठ्यात राहणाऱ्या एका बागायतदाराला न्याय देत, सील तोडून त्याची घरवापसी करण्यात आली.</li>
      <li>२०२३ – बँकेने बळकावलेल्या मिळकतीविरोधात मौजे तारदाळ, ता. हातकणंगले येथे मोठ्या प्रमाणावर निदर्शने करण्यात आली.</li>
      <li>२०२३ – ठाणे येथे कायदेशीर सल्ला व मार्गदर्शनासाठी विशेष शिबिराचे आयोजन करण्यात आले.</li>
      <li>२०२५ – जि. सांगली अंतर्गत इस्लामपूर व रामानंदनगर या गावांमध्ये कर्जदारांसाठी सशक्त मार्गदर्शन मेळावे आयोजित करण्यात आले.</li>
    </ul>

  </div>
</section>

      <section className="pir-section">
      <div className="pir-header">
       <h2>
  <FontAwesomeIcon icon={faMapMarkerAlt} className="location-icon" />
  संचालन मंडळ
</h2>

      </div>

      <div className="pir-grid">
        {teamData.map((member, index) => (
          <div key={index} className="pir-card">
            <div className="pir-image-wrapper">
              <img src={member.image} alt={member.name} className="pir-image" />
              <div className="pir-overlay" onClick={() => setOpenBoardIndex(index)}>
                Read Bio <span className="pir-arrow">→</span>
              </div>
            </div>
            <div className="pir-info">
              <h3>{member.name}</h3>
              <p>{member.title}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Popup Overlay - like PIR.org */}
      {openBoardIndex !== null && (
        <div className="pir-modal-overlay" onClick={handleClose}>
          <div className="pir-modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="pir-modal-close" onClick={handleClose}>×</button>
            <img
              src={teamData[openBoardIndex].image}
              alt={teamData[openBoardIndex].name}
              className="pir-modal-image"
            />
            <h3>{teamData[openBoardIndex].name}</h3>
            <p className="pir-modal-title">{teamData[openBoardIndex].title}</p>
            <div className="pir-bio">
              <p>{teamData[openBoardIndex].bio}</p>
              {teamData[openBoardIndex].chartImage && (
                <img
                  src={teamData[openBoardIndex].chartImage}
                  alt="Chart"
                  className="pir-chart-image"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </section>
     
    {/* <section className="pir-section">
        <div className="pir-header">
          <h2>
            <FontAwesomeIcon icon={faMapMarkerAlt} className="location-icon" />
            Sangli District Management Team
          </h2>
        </div>

        <div className="pir-grid">
          {boardMembers.map((member, index) => (
            <div key={index} className="pir-card">
              <div className="pir-image-wrapper">
                <img src={member.image} alt={member.name} className="pir-image" />
                <div className="pir-overlay" onClick={() => setOpenSangliIndex(index)}>
                  Read Bio <span className="pir-arrow">→</span>
                </div>
              </div>
              <div className="pir-info">
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
     
      {openSangliIndex !== null && (
        <div className="pir-modal-overlay" onClick={handleClose}>
          <div className="pir-modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="pir-modal-close" onClick={handleClose}>×</button>
            <img
              src={boardMembers[openSangliIndex].image}
              alt={boardMembers[openSangliIndex].name}
              className="pir-modal-image"
            />
            <h3>{boardMembers[openSangliIndex].name}</h3>
            <p className="pir-modal-title">{boardMembers[openSangliIndex].title}</p>
            <div className="pir-bio">
              <p>{boardMembers[openSangliIndex].bio}</p>
              {boardMembers[openSangliIndex].chartImage && (
                <img
                  src={boardMembers[openSangliIndex].chartImage}
                  alt="Chart"
                  className="pir-chart-image"
                />
              )}
            </div>
          </div>
        </div>
      )}*/}

    {/* <section className="team-past-pirboard">
  <article className="content-width">
    <div className="team-past-pirboard__top">
      <h2 className="text--display-l">Past PIR Board Directors</h2>
    </div>

    <ul className="team-past-pirboard__grid">
      {visibleDirectors.map((director, index) => (
        <li key={index} className="past-director-card">
          <strong>{director.name}</strong>
          <br />
          <span className="year-info">
            ({director.years}
            {director.note ? `) (${director.note}` : ")"}
          </span>
        </li>
      ))}
    </ul>

    {pastDirectors.length > 7 && (
      <div className="view-more-container">
        <button onClick={() => setShowAll(!showAll)} className="view-more-btn">
          {showAll ? 'View Less' : 'View More'}
        </button>
      </div>
    )}
  </article>
</section>*/}
  {/*<section className="pir-advisory-section">
      <div className="pir-container">
        <h2 className="pir-title">PIR Advisory Council</h2>
        <div className="pir-council-list">
          {advisoryCouncil.map((member, index) => (
            <div key={index} className="pir-member-card">
              <h3 className="pir-member-name">{member.name}</h3>
              <p className="pir-member-year">{member.year}</p>
              <p className="pir-member-info">{member.info}</p>
            </div>
          ))}
        </div>
      </div>
    </section>*/}
    
       
<footer className="pir-footer">
  <div className="footer-container">
    {/* Logo on the left - vertical */}
    <div className="footer-left">
      <img src="/web.png" alt="Logo" className="footer-logo-vertical" />
    </div>

    {/* Center: Two columns of links */}
    <div className="footer-center">
      <div className="footer-links-columns">
         <ul className="footer-links">
                <li>
                            <a href="/privacypolicy">
                              <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
                            </a>
                          </li>
                          <li>
                            <a href="/signuppolicy">
                              <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
                            </a>
                          </li>
                        </ul>
                        <ul className="footer-links">
                          <li>
                            <a href="/termsuse">
                              <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
                            </a>
                          </li>
                          <li>
                            <a href="/disclaimer">
                              <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
                            </a>
                          </li>
        </ul>
      </div>
    </div>

    {/* Social links */}
    <div className="footer-right">
      
     <div className="footer-social">
   <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
              <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
              <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
              <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
              <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
</div>
    </div>
  </div>

  {/* Bottom Text */}
 <div className="footer-bottom">
  <p className="marathi-text">
    © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
  </p>
</div>
</footer>
<ul className="right-side-icons">
    <li>
          <a href="/" className="icon-link pulse-glow" title="Home">
            <FontAwesomeIcon icon={faHome} />
          </a>
        </li>
        <li>
          <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </li>
       
      </ul>

    </>
  );
};

export default Header;
